import { useUser } from "../../../../../hook";
import { useDocumentInfo, usePublicDocumentContent } from "../../../hooks";
import { ContentDiffViewer } from "../../../../../components/diff-viewer";
import { Button, Empty, Form, Select, Space, Spin } from "antd";
import { useSearchParams } from "../../../../../hook/use-search-params";
import { useCallback } from "react";

export const HistoryVersionDiffView = () => {
  const { checkCurrentUser } = useUser();
  const { data } = useDocumentInfo();
  const [form] = Form.useForm();
  const {
    isLoading,
    versionOptions,
    differenDataByVersion,
    data: contentsData,
    previousVersion,
    currentVersion,
  } = usePublicDocumentContent();
  const { searchParams, replaceSearchParams } = useSearchParams();

  const handleFinish = (values: { previousVersion: number; currentVersion: number }) => {
    searchParams.set("previousVersion", values.previousVersion + "");
    searchParams.set("currentVersion", values.currentVersion + "");
    replaceSearchParams(searchParams);
  };

  const getParentTitle = useCallback(
    (CustomParentId: string) => {
      let parentTitle = "";
      const parentContent = contentsData.find((e: any) => e.CustomId === CustomParentId);
      parentTitle = parentContent?.Title ? parentContent?.Content : "";
      if (!parentContent?.Title) {
        const newParentContent = contentsData.find((e: any) => e.CustomId === parentContent?.CustomParentId);
        parentTitle = newParentContent?.Content || "";
      }
      return parentTitle;
    },
    [contentsData],
  );

  if (isLoading) return <Spin />;

  return (
    <div>
      <Form form={form} onFinish={handleFinish} initialValues={{ previousVersion, currentVersion }}>
        <Space align="start">
          <Form.Item name="previousVersion">
            <Select options={versionOptions} placeholder="Chọn phiên bản để so sánh" style={{ width: "200px" }} />
          </Form.Item>
          <Form.Item name="currentVersion">
            <Select options={versionOptions} placeholder="Chọn phiên bản hiện tại" style={{ width: "200px" }} />
          </Form.Item>
          <Button type="primary" htmlType="submit">
            Xác nhận
          </Button>
        </Space>
      </Form>
      <div style={{ height: "500px", overflow: "auto" }}>
        {differenDataByVersion.length > 0 ? (
          differenDataByVersion
            .filter(
              (r: any) =>
                r[1]?.Permissions?.find((e: any) => checkCurrentUser(e.employeeEmail)) ||
                !data?.isContentPermission ||
                checkCurrentUser(data?.userEmail || ""),
            )
            .map((row: any, index: any) => {
              const cVersionTitle = getParentTitle(row[1].CustomParentId);
              const pVersionTitle = getParentTitle(row[0].CustomParentId);
              const cVersionSummary = row[1].ContentSummary;
              return (
                <ContentDiffViewer
                  oldContent={row[0]?.Content}
                  newContent={row[1]?.Content}
                  cVersionTitle={cVersionTitle}
                  pVersionTitle={pVersionTitle}
                  cVersionSummary={cVersionSummary}
                  id={row[1]?.Id}
                  key={index}
                  index={index}
                  isVisibleViewHistoryButton={false}
                />
              );
            })
        ) : (
          <Empty description="Phiên bản hiện tại không có sự thay đổi" />
        )}
      </div>
    </div>
  );
};
